export default __webpack_public_path__ + "static/media/Futura Bold font.7bfa5614.ttf";